import { useMemo } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';
import NewWcnTable, { DataTableColumn } from '@/components/datatable/NewWcnTable.tsx';
import { LogicServiceLayout, LogicServiceVersion } from '@/services/logicServiceManagementService';

interface LogicServiceHistoryTableProps {
    layout: LogicServiceLayout;
    onHistoryDownload: (layoutName: string, version: LogicServiceVersion) => void;
}

const LogicServiceHistoryTable = ({ layout, onHistoryDownload }: LogicServiceHistoryTableProps) => {
    const { t } = useTranslation();

    const columns: DataTableColumn<LogicServiceVersion>[] = useMemo(
        () => [
            {
                text: '',
                value: 'layoutName',
                sortable: false,
                render: () => <span />
            },
            {
                text: '',
                value: 'version',
                width: 80,
                sortable: false,
                render: (row) => <span style={{ fontSize: 12 }}>{row.version}</span>
            },
            {
                text: '',
                value: 'uploadTime',
                width: 190,
                sortable: false,
                render: (row) => {
                    const dt = DateTime.fromISO(row.uploadDateTime).toLocal();
                    return (
                        <span style={{ fontSize: 12 }}>
                            {dt.toFormat('dd.MM.yyyy')}
                            <br />
                            {dt.toFormat('HH:mm')}
                        </span>
                    );
                }
            },
            {
                text: '',
                value: 'uploadedBy',
                width: 230,
                sortable: false,
                render: (row) => (
                    <span style={{ fontSize: 12, whiteSpace: 'normal', wordBreak: 'break-word' }}>
                        {row.uploadedBy}
                    </span>
                )
            },
            {
                text: '',
                value: 'changes',
                sortable: false,
                render: (row) => (
                    <span style={{ fontSize: 12, whiteSpace: 'normal', wordBreak: 'break-word' }}>
                        {row.changeDescription}
                    </span>
                )
            },
            {
                text: '',
                value: 'assignedShops',
                width: 220,
                sortable: false,
                render: () => <span />
            },
            {
                text: '',
                value: 'actions',
                width: 140,
                sortable: false,
                isAction: true,
                render: (row) => (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', pl: '34px' }}>
                        <IconButton
                            size="small"
                            title={t('download')}
                            onClick={() => onHistoryDownload(layout.name, row)}
                        >
                            <i className="bi bi-download" />
                        </IconButton>
                    </Box>
                )
            }
        ],
        [t, layout.name, onHistoryDownload]
    );

    return (
        <Box className="logic-service-history-wrapper">
            <Box className="logic-service-history-title-row">
                <Typography className="logic-service-history-title">{t('history')}</Typography>
            </Box>
            <NewWcnTable columns={columns} data={layout.history} size="small" noDataMessage="" />
        </Box>
    );
};

export default LogicServiceHistoryTable;
